export const COMPANY_FETCHING = "COMPANY_FETCHING";
export const COMPANY_FAILED = "COMPANY_FAILED";
export const COMPANY_SUCCESS = "COMPANY_SUCCESS";

export const VENDORS_FETCHING = "VENDORS_FETCHING";
export const VENDORS_FAILED = "VENDORS_FAILED";
export const VENDORS_SUCCESS = "VENDORS_SUCCESS";

